import React, {useEffect, useState} from 'react';
import {APP} from "../../Utils/Constants.ts";

interface PublicProps {
  handlePublic: (filterId:string, value:any) => void;
  value: Filter|undefined;
}

interface Option {
  label: string;
  value: number;
}

const Public: React.FC<PublicProps> = ({ value, handlePublic }) => {

  const getDefaultValue = () => {
    return value? value.values : []
  }

  const [publicValue, setPublicValue] = useState<number[]>(getDefaultValue);

  const values: Record<number, Option> = {
    0: { label: '- de 18 ans', value: 0 },
    1: { label: '18 à 25 ans', value: 1 },
    2: { label: '25 ans et +', value: 2 },
  };

  if (!values) {
    return null;
  }

  const handleChange = (e: any) => {
    const { checked, value } = e.target;

    setPublicValue(prev => {
      // If checked, add the value to the array
      if (checked) {
        return [...prev, value];
      } else {
        // If unchecked, remove the value from the array
        return prev.filter(item => item !== value);
      }
    });
  };

  useEffect(() => {
    handlePublic(APP.FILTER.PUBLIC.FIELD, publicValue)
  }, [publicValue]);

  const isChecked = (id:number) => {
    if(value && Array.isArray(value.values)) {
      return value.values.includes(id.toString());
    }
    return false
  }

  return (
    <div className={'filter-wrapper duration__wrapper'}>
      <span className="filter-label">{Drupal.t("Public")}</span>
      {Object.keys(values).map((index) => {
        const option = values[parseInt(index, 10)];
        const id = `checkbox-public-${option.value}`;
        return (
          <div key={id} className={'checkbox-input'}>
            <input
              checked={isChecked(option.value)}
              onChange={handleChange}
              id={id}
              name={id}
              type={'checkbox'}
              value={option.value}
            />
            <label htmlFor={id}>{option.label}</label>
          </div>
        );
      })}
    </div>
  );
};

export default Public;
